<template>
  <div>
    <van-notice-bar id="comNoticeBar" mode="closeable" scrollable  @replay="handleNoticeBarRelay">
      {{ noticeInfo[noticeIndex] }}
    </van-notice-bar>
  </div>
</template>
<style >
#comNoticeBar{
  width:calc(100% - 0.5rem);
  height:0.5rem;
  position:fixed;
  bottom:10px;
  z-index:10000;
 
}
</style>
<script>

export default {
  name: "mqttws",
  data() {
    return {
      noticeIndex: 0,
      noticeInfo: [
        "微信搜索速得尔公众号,实时查看比分成绩",
        "比分直播为直播成绩，最终成绩以现场公告为准",
      ],
    };
  },
  methods: {
    // 消息提示框重新开始方法
    handleNoticeBarRelay(data) {
      this.noticeIndex =
        this.noticeIndex < this.noticeInfo.length - 1 ? this.noticeIndex + 1 : 0;
     
    },
  },
  computed: {},
};
</script>
